export default "__VITE_ASSET__dbb84f78__"